/**
 * File: PageError.tsx
 * Path: apps/admin/src/modules/app/components/PageError.tsx
 * Description: What a page shows when it crashes: a plain sentence, the
 * error itself, and the way out (reload, or Diagnostics to copy a report).
 * The error is recorded in this device's error log once.
 */

import React from "react";
import { Link } from "react-router-dom";
import { ADMIN_PATHS } from "@idk/config";
import { Button } from "@idk/ui";
import { usePageErrorController } from "@/modules/app/hooks/usePageErrorController";

export const PageError: React.FC = () => {
  const { message, pathname, reload } = usePageErrorController();

  return (
    <div className="max-w-prose-wide space-y-stack-md" role="alert">
      <h1 className="text-xl font-bold">This page hit a problem</h1>
      <p className="text-sm text-muted-foreground">
        Nothing was lost. Reload to try again. If it keeps happening, open Diagnostics and press Copy report, then send
        it to Claude.
      </p>
      <p className="break-words rounded-none border border-border/60 p-gutter-sm font-mono text-sm">{message}</p>
      <div className="flex flex-wrap gap-stack-sm">
        <Button onClick={reload}>Reload</Button>
        {pathname !== ADMIN_PATHS.diagnostics && (
          <Button asChild variant="outline">
            <Link to={ADMIN_PATHS.diagnostics}>Open Diagnostics</Link>
          </Button>
        )}
      </div>
    </div>
  );
};
